(function() {

	function ext(name) {
		var i = name.indexOf('.');
		return !!~i ? name.substr(i) : undefined; 
	}
	
	function slug(name) {
		return name.toLowerCase()
			.replace(/\.[^/.]+$/, '') // trim file extension
			.replace(/\//g, '-'); // replace whacks with hyphens
	}

	define('template',{
		
		load: function (name, req, onLoad, config) {
			req(['core/can', 'text!'+name], function (can, html) {
				
				if (config && config.isBuild) {
	            
	                onLoad();
	            
	            } else {
				
					var id = slug(name);
					
					if (can.view.cachedRenderers[id] === undefined) {
						can.view.registerView(id, html, ext(name));
					}
					
					onLoad(id);
				}
			});
		},
		
		write: function (pluginName, moduleName, write) {
		
			var id = slug(moduleName);
		
			write.asModule(pluginName + '!' + moduleName,
				[
					'define(["core/can", "text!', moduleName, '"], function (can, html) {',
						'if (can.view.cachedRenderers["', id, '"] === undefined) {',
							'can.view.registerView("', id, '", html, "', ext(moduleName), '");',
						'}',
						'return "', id, '";',
					'});'
				].join('')
			);
		}
	});

})();
